<script lang="ts" setup>
import { useConfigStore } from '~/stores/config';

definePageMeta({
  authType: [AUTH_ROUTE_TYPE_NONE],
  layout: 'unified-public',
  unifiedPublic: {
    fullWidth: true,
    fixedHeader: true,
    showLoader: true,
  },
  // A schools cluster serves its own landing page at `/` with its own
  // header/footer chrome, so the consumer public layout must not wrap it.
  middleware: [
    () => {
      if (useConfigStore().isSchoolsCluster) {
        setPageLayout('default');
      }
    },
  ],
})

const { t } = useI18n();
const configStore = useConfigStore();

const showSchoolsLanding = computed(() => configStore.isSchoolsCluster);

if (!showSchoolsLanding.value) {
  useSeoMeta({
    title: t('unified.seo.landing.title'),
    description: t('unified.seo.landing.description'),
    ogTitle: t('unified.seo.landing.ogTitle'),
    ogDescription: t('unified.seo.landing.ogDescription'),
    ogType: 'website',
  });

  const analytics = useAnalyticsService();
  onMounted(() => {
    analytics.track(EVENTS.UNIFIED_PUBLIC_PAGE_VIEWED, { page: 'home' });
  });
}
</script>

<template>
  <SchoolsLandingTeachersView v-if="showSchoolsLanding" />
  <KUIUnifiedLayoutPublicParallax v-else>
    <template #hero>
      <UnifiedLandingHero />
    </template>

    <div class=" px-4 py-16 bg-white">
      <div class="max-w-7xl mx-auto">
        <UnifiedLandingFindAFuture class="mb-2" />
        <UnifiedLandingVirtualCareer class="mt-16" />
      </div>
    </div>
    <div class="mx-auto my-32">
      <UnifiedLandingMakeAPlan />
    </div>
    <div class="max-w-7xl mx-auto px-4">
      <UnifiedLandingRealCareers class="my-32 px-4" />
    </div>
    <div class="max-w-7xl mx-auto overflow-hidden">
      <UnifiedLandingGetLifeReady />
    </div>
    <div class="hidden md:block max-w-7xl mx-auto md:px-4 pb-16">
      <UnifiedLandingYourThing />
    </div>
  </KUIUnifiedLayoutPublicParallax>
</template>
